// Premium — Meta frequency − 1, i.e. the share of impressions beyond the first
// one per person reached. Lower is better: 0 means everyone who saw the ad saw
// it once, and climbing premium means the same people are being served again
// because the audience is running out.
//
// Shared by the Meta Ads Insights and Creative Performance dashboards. It lives
// here rather than in either page so the two can't drift into disagreeing about
// what counts as a tired creative — the same ad has to read the same on both.

export const DEFAULT_PREMIUM_MAX = 0.15;

export function fmtPremium(v: unknown): string {
  return typeof v === 'number' && isFinite(v) ? `${Math.round(v * 100)}%` : '–';
}

export type PremiumTone = 'good' | 'bad' | '';

// Green below the target, red past twice it, neutral in the band between.
export function premiumTone(
  v: number | null | undefined,
  max: number = DEFAULT_PREMIUM_MAX,
): PremiumTone {
  if (typeof v !== 'number') return '';
  return v < max ? 'good' : v > max * 2 ? 'bad' : '';
}
